import { render, staticRenderFns } from "./ReviewChallengeModal.vue?vue&type=template&id=621febbc&scoped=true&"
import script from "./ReviewChallengeModal.vue?vue&type=script&lang=js&"
export * from "./ReviewChallengeModal.vue?vue&type=script&lang=js&"
import style0 from "./ReviewChallengeModal.vue?vue&type=style&index=0&id=621febbc&lang=scss&scoped=true&"
import style1 from "./ReviewChallengeModal.vue?vue&type=style&index=1&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "621febbc",
  null
  
)

export default component.exports